var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiguracaoHorarios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "configuracao-horarios",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "configuracao-horarios_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x36_3H05W.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.4,91.5c-0.3,2.1-0.6,4.2-1.1,6.3c-3.4,15.4-16.3,27.7-32,30.3c-10.2,1.7-19.7-0.2-28.5-5.7 c-0.4-0.3-0.8-0.5-1.2-0.8c-0.1-0.1-0.2-0.1-0.4-0.3c1.6-1,7.1-5.3,7.1-5.3s1.1,0.7,3.5,1.8c18.8,8.4,40.8-3.8,43.8-24.1 c2.6-17.7-9.5-33.8-27.2-36.1c-9-1.2-17.1,1.3-24.2,7c-0.2,0.2-0.5,0.4-0.6,0.5c-2.2-1.8-4.3-3.5-6.5-5.2c2.1-2,4.6-3.8,7.2-5.4 c23.9-13.7,54,0.1,59.2,27.2c0.3,1.5,0.5,3.1,0.7,4.7C138.4,87.9,138.4,89.7,138.4,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,37.1c2,0.5,3.9,1.1,5.6,2.4C65.3,42.8,67,48.7,65,54c-2,5.1-7.3,8.4-12.7,7.9 c-5.7-0.6-10.2-4.8-11.1-10.4c-1-6.6,3.3-12.8,9.9-14.1c0.2,0,0.4-0.1,0.7-0.2C52.9,37.1,54,37.1,55.1,37.1z M53.4,53.6 c2.3,0,4.2-1.8,4.2-4.1s-1.8-4.1-4.1-4.2c-2.3,0-4.2,1.8-4.2,4.1C49.3,51.7,51.1,53.6,53.4,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.8,104.7c2.8,0,5.5,0,8.2,0c0,12.8,0,25.5,0,38.2c-2.7,0-5.4,0-8.2,0c0-9.9,0-19.9,0-29.9 c-2.8,0-5.5,0-8.3,0c0-0.5,0-0.8,0-1.2c0-11.1,0-22.1,0-33.2c0-7.4,5.4-12.8,12.8-12.8c5.3,0,10.5,0,15.8,0 c7.3,0,12.7,5.4,12.7,12.7c0,11.1,0,22.2,0,33.3c0,0.3,0,0.7,0,1.1c-2.8,0-5.5,0-8.2,0c0,10,0,19.9,0,29.9c-2.8,0-5.5,0-8.2,0 c0-12.7,0-25.4,0-38.2c2.7,0,5.4,0,8.2,0c0-0.4,0-0.7,0-1.1c0-8.3,0-16.7,0-25c0-2.9-1.7-4.5-4.6-4.6c-5.2,0-10.5,0-15.7,0 c-2.8,0-4.5,1.7-4.5,4.5c0,8.4,0,16.7,0,25.1C40.8,104,40.8,104.3,40.8,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.7,66.3c2.8,0,5.4,0,8.2,0c0,6.4,0,12.8,0,19.4c4.4,0,8.6,0,13,0c0,2.8,0,5.5,0,8.3c-7.1,0-14.1,0-21.2,0 C94.7,84.7,94.7,75.6,94.7,66.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguracaoHorarios);
export default __webpack_public_path__ + "static/media/configuracao-horarios.407c0fd585518f0d3ad48100802fd9ce.svg";
export { ForwardRef as ReactComponent };